import { Box, Button, TextField, Modal, Typography } from '@mui/material';
import { useCallback, useState } from 'react';
import { IModalWidgetProps, User } from '~/shared/types/types';
import { formatCustomer } from '~/shared/utils/formatCustomer';

export const ModalWidget: React.FC<IModalWidgetProps> = ({
  open,
  handleClose,
}) => {
  const [id, setID] = useState('');
  const [name, setName] = useState('');
  const [customer_id, setCustomerID] = useState('');
  const [created_at, setCreatedAT] = useState('');
  const [created_by, setCreatedBY] = useState('');
  const [assigned_to, setAssaignedTO] = useState('');
  const [comment, setComment] = useState('');

  const data: User = {
    id,
    name,
    customer_id,
    created_at,
    created_by,
    assigned_to,
    comment,
  };

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description">
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 600,
          bgcolor: 'background.paper',
          borderRadius: '12px',
          boxShadow: 24,
          pt: 3,
          px: 3,
          pb: 3,
        }}>
          <Box
            sx={{
              paddingBottom: '32px',
              display: 'flex',
              flexDirection: 'column',
              gap: '12px',
            }}>
            <Typography id="modal-modal-title" variant="h3" component="h2">
              Profile
            </Typography>
            <Typography variant="h5" component="h2">
              Lets add new contact for your application. fill the all field and
              click on submit button.
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'row' }}>
            <Box
              sx={{
                display: 'flex',
                flex: 1,
                flexDirection: 'column',
                gap: '12px',
              }}>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  gap: '24px',
                  alignItems: 'center',
                }}>
                <Typography variant="h6" sx={{ textAlign: 'center' }}>
                  ID:
                </Typography>

                <TextField
                  id="outlined-basic"
                  label="ID"
                  variant="outlined"
                  sx={{ textAlign: 'center' }}
                  onChange={e => setID(e.target.value)}
                />
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  gap: '24px',
                  alignItems: 'center',
                }}>
                <Typography variant="h6">Имя:</Typography>
                <TextField
                  id="outlined-basic"
                  label="Имя"
                  variant="outlined"
                  onChange={e => setName(e.target.value)}
                />
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  gap: '24px',
                  alignItems: 'center',
                }}>
                <Typography variant="h6">Customer ID:</Typography>
                <TextField
                  id="outlined-basic"
                  label="Outlined"
                  variant="outlined"
                  value={formatCustomer(customer_id)}
                  onChange={e => setCustomerID(e.target.value.replace(/\D/g, ''))}
                />
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  gap: '24px',
                  alignItems: 'center',
                }}>
                <Typography variant="h6">Дата создания:</Typography>
                <TextField
                  id="outlined-basic"
                  label="Дата создания"
                  variant="outlined"
                  onChange={e => setCreatedAT(e.target.value)}
                />
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  gap: '24px',
                  alignItems: 'center',
                }}>
                <Typography variant="h6">Создан:</Typography>
                <TextField
                  id="outlined-basic"
                  label="Создан"
                  variant="outlined"
                  onChange={e => setCreatedBY(e.target.value)}
                />
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  gap: '24px',
                  alignItems: 'center',
                }}>
                <Typography variant="h6">Назначен:</Typography>
                <TextField
                  id="outlined-basic"
                  label="Назначен"
                  variant="outlined"
                  onChange={e => setAssaignedTO(e.target.value)}
                />
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  gap: '24px',
                  alignItems: 'center',
                }}>
                <Typography variant="h6">Комментарий:</Typography>
                <TextField
                  id="outlined-basic"
                  label="Комментарий"
                  variant="outlined"
                  onChange={e => setComment(e.target.value)}
                />
              </Box>
            </Box>
          </Box>

          <Typography
            id="modal-modal-description"
            sx={{ mt: 2, color: 'black' }}></Typography>
          <Box sx={{ display: 'flex', flexDirection: 'row', gap: '8px' }}>
            <Button variant="contained" type="submit">
              Save
            </Button>
            <Button variant="outlined">Cancel</Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};
